module.exports = __webpack_public_path__ + "static/Brand-USA-logo-Discover-America-68982bfba5e0491d4a317aee9c0ec99e.png";